export function formatHashrate(hashrate: string | number): string {
  const value = typeof hashrate === 'string' ? parseFloat(hashrate) : hashrate;
  if (value < 1000) return `${value.toFixed(2)} H/s`;
  if (value < 1000000) return `${(value / 1000).toFixed(2)} KH/s`;
  if (value < 1000000000) return `${(value / 1000000).toFixed(2)} MH/s`;
  if (value < 1000000000000) return `${(value / 1000000000).toFixed(2)} GH/s`;
  return `${(value / 1000000000000).toFixed(2)} TH/s`;
}